import { UserTypes } from '$types/UserTypes';
import getUserType from '$utils/getUserType';

interface SPKSingleEmployerCandidateShowcaseInterface {
  icon: any;
  title: string;
  link?: string;
  onClick?: () => void;
  additionalClassNames?: string;
  segmentEvent?: () => void;
  onCopyVideoShareUrl?: () => void;
}

const SPKSingleEmployerCandidateShowcase = ({
  link,
  onClick,
  icon,
  title,
  additionalClassNames,
  segmentEvent,
  onCopyVideoShareUrl,
}: SPKSingleEmployerCandidateShowcaseInterface) => {
  if (link && !link?.startsWith('http:') && !link?.startsWith('https:')) {
    link = `//${link}`;
  }

  const userType = getUserType();

  const onClickHandler = (ev: any) => {
    if (!link || link === '') ev.preventDefault();
    if (onClick) onClick();
    if (segmentEvent) segmentEvent();
  };

  return (
    <div className={additionalClassNames}>
      <a
        href={link}
        target="_blank"
        rel="noreferrer"
        onClick={onClickHandler}
        className="inline-block"
      >
        <div className="flex flex-row items-start gap-2 text-sm">
          {userType === UserTypes.INTERNAL && onCopyVideoShareUrl && (
            <button
              type="button"
              onClick={(ev) => {
                ev.preventDefault();
                ev.stopPropagation();
                onCopyVideoShareUrl();
              }}
              title="Copy Video Share Url"
              aria-label="Copy video share url"
            >
              <span
                className={`pi pi-clone mt-[2px] ${
                  userType === UserTypes.INTERNAL
                    ? 'text-internal-main'
                    : 'text-employer-primary'
                }`}
              />
            </button>
          )}
          <span className="mt-[2px]">{icon}</span>
          <div className="capitalize text-sm">{title}</div>
        </div>
      </a>
    </div>
  );
};

SPKSingleEmployerCandidateShowcase.defaultProps = {
  link: '',
  onClick: () => {},
  additionalClassNames: '',
  segmentEvent: () => {},
  onCopyVideoShareUrl: undefined,
};

export default SPKSingleEmployerCandidateShowcase;
